import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIVWinConfigs} from "../../configs/BenjiKIVWinConfigs";
import {BenjiKIVStatics} from "../../BenjiKIVStatics";
import {BenjiKIV} from "../../BenjiKIV";
import {gsap} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {BenjiKIVSymbol} from "../../reels/BenjiKIVSymbol";
import {BenjiKIVSymbolStates} from "../../../core/reel/ReelInterfaces";
import {BenjiKIVSpine} from "../../components/BenjiKIVSpine";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";
import {SpineUtils} from "../../utils/SpineUtils";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";

/**
 * Created by Jerker Nord on 2022-11-23.
 */

export class BenjiKIVInitialWinView extends PIXI.Container implements StageLayer {

    //Add 1 = split, 2 = normal, 3 = 2 sym stacked, 4 = full stacked
    private static SPINE_ANIMATION_NAMES:string[] = ["Win_Tiny_", "Win_Small_", "Win_Medium_", "Win_Large_"];

    private _largeWinGlassAnimation:TimelineSprite;

    constructor() {
        super();
        this.name = "BenjiKIVInitialWinView";
        this.position = BenjiKIVStatics.MAIN_REELS_VIEW_POSITION;
        this.init();
    }

    private init() {
        this._largeWinGlassAnimation = new TimelineSprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.BROKEN_GLASS_ANIMATION));
        this._largeWinGlassAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        this._largeWinGlassAnimation.scale.set(2.5, 2.5);
        this._largeWinGlassAnimation.anchor.set(0.5, 0.5);
        this._largeWinGlassAnimation.position.set(290, 480);
        this._largeWinGlassAnimation.visible = false;
        BenjiKIV.symbolsOnTopView.addChild(this._largeWinGlassAnimation);
    }

    public getInitialWinAnimation():gsap.core.Timeline {
        let betlineHighlightSound:number = 0;
        let winType:string = BenjiKIVWinConfigs.getWinType(BenjiKIV.model.winRatio);
        let baseAnimationName:string = "",
            symbol:BenjiKIVSymbol;
        switch(winType) {
            case BenjiKIVWinConfigs.TINY:
                baseAnimationName = BenjiKIVInitialWinView.SPINE_ANIMATION_NAMES[0];
                betlineHighlightSound = 0;
                break;
            case BenjiKIVWinConfigs.SMALL:
                baseAnimationName = BenjiKIVInitialWinView.SPINE_ANIMATION_NAMES[1];
                betlineHighlightSound = 0;
                break;
            case BenjiKIVWinConfigs.MEDIUM:
                baseAnimationName = BenjiKIVInitialWinView.SPINE_ANIMATION_NAMES[2];
                betlineHighlightSound = 1;
                break;
            case BenjiKIVWinConfigs.LARGE:
                baseAnimationName = BenjiKIVInitialWinView.SPINE_ANIMATION_NAMES[3];
                betlineHighlightSound = 2;
                break;
            default:
        }

        const allWinTL:gsap.core.Timeline = gsap.timeline({delay : 0.1});
        allWinTL.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.BETLINE_HIGHLIGHT[betlineHighlightSound])});
        const subTLs:gsap.core.Timeline[] = [];
        const wins:boolean[][] = BenjiKIV.model.allWinSymPositions;
        if(wins) {
            for(let i:number = 0; i < wins.length; i++) {
                for(let j:number = 0; j < wins[i].length; j++) {
                    const tl:gsap.core.Timeline = gsap.timeline();
                    if(wins[i][j]) {
                        symbol = (BenjiKIV.allReelView.reelModels[i].reelView.symbols[j + 3] as BenjiKIVSymbol);

                        if((!BenjiKIV.model.reelsStackedStatus[i] || (BenjiKIV.model.reelsStackedStatus[i] && j === 1))) {
                            let animationName:string = baseAnimationName;
                            if(symbol.splitLevel > 1) {
                                //Split symbol. Need two half size frames
                                animationName += "1";
                                subTLs.push(this.getWinTL(animationName, i, j, 0));
                                subTLs.push(this.getWinTL(animationName, i, j, 1));
                            } else {
                                //Part of or fully visible stacked at bottom of reel
                                if(symbol.stackedSymbolName.indexOf("_TOP") > -1) {
                                    //If only top of stacked is visible, play normal frame
                                    if((j + 3) == 5) {
                                        animationName += "2";
                                        subTLs.push(this.getWinTL(animationName, i, j, 2));
                                    }
                                }
                                //Part of or fully visible stacked at top of reel
                                else if(symbol.stackedSymbolName.indexOf("_BOT") > -1) {
                                    //If only bottom of stacked is visible, play normal frame
                                    if((j + 3) == 3) {
                                        animationName += "2";
                                        subTLs.push(this.getWinTL(animationName, i, j, 2));
                                    }
                                } else if(symbol.stackedSymbolName.indexOf("_MID") > -1) {
                                    if((j + 3) == 4) {
                                        animationName += "4";
                                        subTLs.push(this.getWinTL(animationName, i, j, 5));
                                    }
                                    if((j + 3) == 3) {
                                        animationName += "3";
                                        subTLs.push(this.getWinTL(animationName, i, j, 3));
                                    }
                                    if((j + 3) == 5) {
                                        animationName += "3";
                                        subTLs.push(this.getWinTL(animationName, i, j, 4));
                                    }
                                } else {
                                    //Normal sym
                                    animationName += "2";
                                    subTLs.push(this.getWinTL(animationName, i, j, 2));
                                }
                            }
                        }
                    } else {
                        let symbolPosition:number = (j + 3);

                        BenjiKIV.overlayScatterPool.playNoWin(i, symbolPosition);

                        //tl.add(() => this.noWinOverlayScatter(i));
                        if(symbolPosition == 3 && BenjiKIV.allReelView.reelModels[i].reelView.symbols[symbolPosition].stackedSymbolName.indexOf("_BOT") > -1) {
                            //Only bottom part of stacked is visible
                            tl.add(() => {
                                (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[i].reelView.symbols[symbolPosition - 1]).getNewStateAnimation(BenjiKIVSymbolStates.NO_WIN, 0.2)
                            });
                        } else if(symbolPosition == 5 && BenjiKIV.allReelView.reelModels[i].reelView.symbols[symbolPosition].stackedSymbolName.indexOf("_TOP") > -1) {
                            //Only top part of stacked is visible
                            tl.add(() => {
                                (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[i].reelView.symbols[symbolPosition + 1]).getNewStateAnimation(BenjiKIVSymbolStates.NO_WIN, 0.2)
                            });
                        } else {
                            tl.add(() => {
                                (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[i].reelView.symbols[symbolPosition]).getNewStateAnimation(BenjiKIVSymbolStates.NO_WIN, 0.2)
                            });
                        }
                    }
                }
            }
        }

        allWinTL.add(
            () => {
                subTLs;
                if(winType == BenjiKIVWinConfigs.LARGE) {
                    this._largeWinGlassAnimation.getAnimationAutoShowHide();
                }
            }
        );

        return allWinTL;
    }

    // Sizes: 0 = split top, 1 = split bottom, 2 = normal, 3 = stacked 2 sym top, 4 = stacked 2 sym bottom, 5 = full stacked
    private getWinTL(animationName:string, reel:number, row:number, size:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        let animation:BenjiKIVSpine = BenjiKIV.initialWinSpinesPool.getAnimation();
        tl.add(() => {
            this.addChild(animation);
            this.resetSpineAnimation(animation);
            animation.position.x = BenjiKIVStatics.symbolWidth * reel;
            animation.position.y = BenjiKIVStatics.symbolHeight * (row + 2);
            switch(size) {
                case 0:
                    animation.position.y -= BenjiKIVStatics.symbolHeight / 4;
                    break;
                case 1:
                    animation.position.y += BenjiKIVStatics.symbolHeight / 4;
                    break;
                case 3:
                    animation.position.y += BenjiKIVStatics.symbolHeight / 2;
                    break;
                case 4:
                    animation.position.y -= BenjiKIVStatics.symbolHeight / 2;
                    break;
                default:
            }
        })
        tl.add(new SpineTween(animation, 0, animationName));
        return tl;
    }

    private resetSpineAnimation(spineAnimation:BenjiKIVSpine):void {
        spineAnimation.alpha = 1;
        SpineUtils.resetSpineAnimation(spineAnimation);
    }

    public hideAndResetAllSpineAnimations():void {
        const usedSpines:BenjiKIVSpine[] = BenjiKIV.initialWinSpinesPool.getAllUsed();
        for(let i:number = 0; i < usedSpines.length; i++) {
            usedSpines[i].alpha = 0;
            usedSpines[i].isUsed = false;
        }
    }
}